import ExpiredAdvertisementCard from './ExpiredAdvertisementCard';
import PendingAdvertisementCard from './PendingAdvertisementCard';
import PublishedAdvertisementCard from './PublishedAdvertisementCard';
import RejectedAdvertisementCard from './RejectedAdvertisementCard';

const AdvertisementStatusController = ({
  storeAd,
  status,
}: {
  storeAd: IGetMyStoreAdsData;
  status: Exclude<StatusList, 'promoted'>;
}) => {
  switch (status) {
    case 'pending':
      return <PendingAdvertisementCard storeAd={storeAd} key={storeAd?.id} />;
    case 'published':
      return <PublishedAdvertisementCard storeAd={storeAd} key={storeAd?.id} />;
    case 'expired':
      return <ExpiredAdvertisementCard storeAd={storeAd} key={storeAd?.id} />;
    case 'rejected':
      return <RejectedAdvertisementCard storeAd={storeAd} key={storeAd?.id} />;

    default:
      return null;
  }
};

export default AdvertisementStatusController;
